// Local search provider id resolver.
//
// Content search runs MiniSearch under two profiles (baseline and tuned) so
// every query is scored under both against the same Algolia results. Which
// engine actually displays is decided by REACT_APP_SEARCH_DISPLAY_ENGINE in
// SearchProviderContainer, and does not change the ids below. Non-content
// registries (navigation, external help, quick actions) are served entirely
// from MiniSearch.
//
// This maps a logical local source to the concrete provider id.

export const PRESENTATION_ENGINES = { MINISEARCH: 'minisearch' }

const LOCAL_PROVIDER_IDS = {
  // `minisearchTuned` and `minisearchRerank` are further shadows over the SAME
  // indices. Neither is ever presented — they exist so the control arm and the
  // candidates can be compared on identical queries rather than week-over-week.
  //
  // The two share a matcher byte-for-byte and differ only in how they ORDER the
  // candidate set, so the gap between them isolates ranking with nothing else
  // moving. See algoliaComparator.js and SEARCH_PROFILES in
  // buildMiniSearchIndices.
  content: {
    minisearch: 'minisearch-content',
    minisearchTuned: 'minisearch-tuned-content',
    minisearchRerank: 'minisearch-rerank-content',
  },
  navigation: { minisearch: 'navigation-minisearch' },
  'external-help': { minisearch: 'external-help-minisearch' },
  'quick-actions': { minisearch: 'quick-actions-minisearch' },
}

/**
 * Resolve a logical local source (`content`, `navigation`, `external-help`,
 * `quick-actions`) to the provider id for the given engine. Falls back to the
 * MiniSearch id for an unknown engine, and returns the base unchanged for an
 * unknown source.
 *
 * @param {string} base
 * @param {('minisearch'|'minisearchTuned'|'minisearchRerank')} engine
 * @returns {string}
 */
export function localProviderId(base, engine) {
  const row = LOCAL_PROVIDER_IDS[base]
  if (!row) return base
  return row[engine] || row.minisearch
}
